// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__19oRs","footer":"ModalUpdate_footer__1vzNG"};